import { ReportCodes } from '@/typings/api/Report'

/**
 * Конфигурация отчетов для сборов данных
 * Добавьте новый объект в массив для добавления нового отчета
 */
export const DATA_COLLECTIONS_REPORTS = [
  {
    id: 'data-collection-status',
    title: 'Статус заполнения по выбранным сборам',
    reportCode: 'dataCollectionStatuses', // Ключ из ReportCodes
    code: ReportCodes.dataCollectionStatuses, // Полный код для API
    paramsModal: 'DataCollectionIdModal', // Компонент модалки для выбора параметров
    description: null, // Опциональное описание отчета
  },
  // {
  //   id: 'data-collection-data',
  //   title: 'Экспорт данных по выбранным сборам',
  //   reportCode: 'dataCollection', // Ключ из ReportCodes
  //   code: ReportCodes.dataCollection, // Полный код для API
  //   paramsModal: 'DataCollectionIdModal', // Компонент модалки для выбора параметров
  //   description: null, // Опциональное описание отчета
  // },
  // Добавьте здесь новые отчеты:
  // {
  //   id: 'another-report',
  //   title: 'Другой отчет',
  //   reportCode: 'anotherReport',
  //   code: ReportCodes.anotherReport,
  //   paramsModal: null, // null - создать отчет без выбора параметров
  //   // paramsModal: 'CustomModal', // или укажите свой компонент модалки
  //   description: 'Описание отчета',
  // },
]

// eslint-disable-next-line no-console
console.log('reportsConfig loaded:', DATA_COLLECTIONS_REPORTS)

